<template>
    <div class="user-get">
        <div class="situation-data">
            <div class="new-add">
                <div class="target-one">
                    <span class="title">日新增(启动)</span>
                    <h2>{{newAddActive}}</h2>
                    <span>日<Icon v-if="newAddActivePercent > 0" size="20" color="red" type="ios-arrow-round-up"/>
                        <Icon v-else size="20" color="green" type="ios-arrow-round-down"/>
                        {{newAddActivePercent|getPercent}}
                    </span>
                </div>
                <div class="target-one">
                    <span class="title">日新增(注册)</span>
                    <h2>{{newAddRegister}}</h2>
                    <span>日<Icon v-if="newAddRegisterPercent > 0" size="20" color="red" type="ios-arrow-round-up"/>
                        <Icon v-else size="20" color="green" type="ios-arrow-round-down"/>
                        {{newAddRegisterPercent|getPercent}}
                    </span>
                </div>
                <div class="target-one">
                    <span class="title">转化率</span>
                    <h2>{{dataTransform}}%</h2>
                    <span>日<Icon v-if="dataTransformPercent > 0" size="20" color="red" type="ios-arrow-round-up"/>
                        <Icon v-else size="20" color="green" type="ios-arrow-round-down"/>
                        {{dataTransformPercent|getPercent}}
                    </span>
                </div>
            </div>
            <div class="invite">
                <div class="target-two">
                    <span class="title">非邀请新增</span>
                    <h2>{{notInviteAdd}}</h2>
                    <span>日<Icon v-if="notInviteAddPercent > 0" size="20" color="red" type="ios-arrow-round-up"/>
                        <Icon v-else size="20" color="green" type="ios-arrow-round-down"/>
                        {{notInviteAddPercent|getPercent}}
                    </span>
                </div>
                <div class="target-two">
                    <span class="title">邀请新增</span>
                    <h2>{{inviteAdd}}</h2>
                    <span>日<Icon v-if="inviteAddPercent > 0" size="20" color="red" type="ios-arrow-round-up"/>
                        <Icon v-else size="20" color="green" type="ios-arrow-round-down"/>
                        {{inviteAddPercent|getPercent}}
                    </span>
                </div>
                <div class="pie-chart">
                    <InviteECharts :pieData="inviteAddPieData"></InviteECharts>
                </div>
            </div>
            <div class="stay">
                <div class="target-three">
                    <span class="title">新增留存</span>
                    <h2>{{newAddStay}}%</h2>
                    <span>日<Icon v-if="newAddStayPercent > 0" size="20" color="red" type="ios-arrow-round-up"/>
                        <Icon v-else size="20" color="green" type="ios-arrow-round-down"/>
                        {{newAddStayPercent|getPercent}}
                    </span>
                </div>
                <div class="heat-chart">
                    <UserStayHeatEChert :heatMapData="newAddStayHeatMapData"></UserStayHeatEChert>
                </div>
            </div>
        </div>
        <div class="line-data">
            <div class="date-select">
                <DateSelect @transmit="getSelectDate"></DateSelect>
            </div>
            <div class="line-echarts">
                <UserGetLineECharts ref="line_charts" :line-data="DateRangeLineData"></UserGetLineECharts>
            </div>
        </div>
        <div class="info-data">
            <div class="table-head">
                <div class="table-title"><span style="font-weight: bold">详细数据</span></div>
                <div>
                    <Button @click="exportData">导出</Button>
                </div>
            </div>
            <UserGetTable ref="child_table" :ajax-data="tableData"></UserGetTable>
        </div>
    </div>
</template>

<script>
    import UserStayHeatEChert from "../components/UserStayHeatEChert";
    import InviteECharts from "../components/InviteECharts";
    import DateSelect from "../components/DateSelect";
    import UserGetLineECharts from "../components/UserGetLineECharts";
    import UserGetTable from "../components/UserGetTable";
    import apis from "../http/api";

    export default {
        name: "UserGet",
        components: {
            UserStayHeatEChert,
            InviteECharts,
            DateSelect,
            UserGetLineECharts,
            UserGetTable
        },
        data() {
            return {
                newAddActive: "",                    // 日新增（启动）
                newAddActivePercent: "",             // 日新增启动变化百分比
                newAddRegister: "",                  // 日新增（注册）
                newAddRegisterPercent: "",           // 日新增注册变化百分比
                dataTransform: "",                   // 转化率
                dataTransformPercent: "",            // 转户率变化百分比
                notInviteAdd: "",                    // 非邀请新增
                notInviteAddPercent: "",             // 非邀请新增变化百分比
                inviteAdd: "",                       // 邀请新增
                inviteAddPercent: "",                // 邀请新增百分比
                inviteAddPieData: [],                // 饼图数据
                newAddStay: "",                      // 新增次留
                newAddStayPercent: "",               // 新增次留百分比
                newAddStayHeatMapData: {},           // 热力图数据
                startSelectDate: null,               // 选择器开始时间
                endSelectDate: null,                 // 选择器结束时间
                DateRangeLineData: {},               // 折线图数据
                tableData: [],                       // 表格数据
            }
        },
        created() {
            this.getNewAddData();
            this.getInviteNewAddData();
            this.getNewAddStayData();
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - 1));
            this.startSelectDate = this.$moment(start).format("YYYY-MM-DD");
            this.endSelectDate = this.$moment(end).format("YYYY-MM-DD");
            this.getUserGetRangeData()
        },
        methods: {
            getNewAddData() {
                apis.user_get_new_add().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.newAddActive = data.new_add_active;
                        this.newAddActivePercent = data.new_add_active_change;
                        this.newAddRegister = data.new_add_register;
                        this.newAddRegisterPercent = data.new_add_register_change;
                        this.dataTransform = data.transfer;
                        this.dataTransformPercent = data.transfer_change
                    }
                }).catch()
            },
            getInviteNewAddData() {
                apis.user_get_invite_new_add().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.notInviteAdd = data.show_data.not_invite_add;
                        this.notInviteAddPercent = data.show_data.not_invite_add_change;
                        this.inviteAdd = data.show_data.invite_add;
                        this.inviteAddPercent = data.show_data.invite_add_change;
                        this.inviteAddPieData = data.chart_data
                    }
                }).catch()
            },
            getNewAddStayData() {
                apis.user_get_new_add_stay().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.newAddStay = data.show_data.new_add_stay;
                        this.newAddStayPercent = data.show_data.new_add_stay_change;
                        this.newAddStayHeatMapData = data.chart_data;

                    }
                }).catch()
            },
            getUserGetRangeData() {
                try {
                    this.$refs.line_charts.loading();
                } catch (e) {
                    console.log('showLoading Error')
                }
                let param_data = {
                    'start_date': this.startSelectDate,
                    'end_date': this.endSelectDate,
                };
                apis.user_get_range_data(param_data).then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.DateRangeLineData = data.chart_data;
                        this.tableData = data.table_data
                    }
                }).catch()
            },
            getSelectDate(data) {
                this.startSelectDate = this.$moment(data[0]).format("YYYY-MM-DD");
                this.endSelectDate = this.$moment(data[1]).format("YYYY-MM-DD");
                this.getUserGetRangeData()
            },
            exportData() {
                this.$refs.child_table.exportData()
            }
        },
        filters: {
            getPercent(val) {
                if (val >= 0) {
                    return '+' + val + '%'
                } else {
                    return val + '%'
                }
            }
        }
    }
</script>

<style scoped>
    .user-get {
        margin: 10px;
    }

    .situation-data {
        /*width: 100%;*/
        display: flex;
        justify-content: space-between;
    }

    .new-add {
        display: flex;
        justify-content: space-between;
        /*border-bottom: solid 1px;*/
        width: 25%;

    }

    .invite {
        display: flex;
        justify-content: space-between;
        /*border-bottom: solid 1px;*/
        width: 25%;
    }

    .pie-chart {
        width: 75%;
    }

    .stay {
        display: flex;
        justify-content: space-between;
        /*border-bottom: solid 1px;*/
        width: 40%;
    }


    .target-one {
        text-align: center;
        width: 30%;
        align-self: center;
    }

    .target-two {
        text-align: center;
        width: 40%;
        align-self: center;
    }

    .target-three {
        text-align: center;
        width: 20%;
        align-self: center;
    }

    .heat-chart {
        /*width: 600px;*/
        width: 80%;
        height: 200px;
    }

    .date-select {
        text-align: center;
        margin-top: 30px;
    }

    .line-echarts {
        height: 500px;
    }

    .info-data {
        padding-top: 30px;
    }

    .table-head {
        display: flex;
        justify-content: space-between;
        padding-bottom: 5px;
    }

    .table-title{
        align-self: center;
    }

</style>